// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3524) return "static/chunks/2170a4aa-a48284763badc73b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","4316":"da7517a88118b074","5203":"77ddae019d833612","6218":"64795a9c47fe7365","6457":"296502e4b0589d20","8436":"39669319b9f31b0a","9839":"97db545449e006dc"}[chunkId] + ".js";
};